import React from 'react';
import PropTypes from 'prop-types';
import ArticleSearchResultsContainer from './ArticleSearchResultsContainer';
import {translateResourceString} from "../../../util/translationUtility";

const ArticleSearchResults = ({ articles,
    paginationViewModel,
    onCurrentItemsPerPageChange,
    onCurrentPageIndexChange,
    onResultClick,
    searchString,
    attributes,
    onAttributeChange,
    expandedArticleFacets,
    showMoreFacets,
    onToggleShowMoreFacet,
    onToggleFacetExpanded,
    onCurrentSortByChange }
) => {
    return (
        <div>
            {articles.length > 0 &&
                <ArticleSearchResultsContainer
                    articles={articles}
                    paginationViewModel={paginationViewModel}
                    onCurrentItemsPerPageChange={onCurrentItemsPerPageChange}
                    onCurrentPageIndexChange={onCurrentPageIndexChange}
                    onResultClick={onResultClick}
                    searchString={searchString}
                    attributes={attributes}
                    showMoreFacets={showMoreFacets}
                    onAttributeChange={onAttributeChange}
                    expandedArticleFacets={expandedArticleFacets}
                    onCurrentSortByChange={onCurrentSortByChange}
                    onToggleShowMoreFacet={onToggleShowMoreFacet}
                    onToggleFacetExpanded={onToggleFacetExpanded}
                />
            }
        </div>
    );
};

ArticleSearchResults.propType = {
    articles: PropTypes.arrayOf(
        PropTypes.shape({
            Title: PropTypes.string,
            Link: PropTypes.string,
            Description: PropTypes.string
        })
    ),
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })),
    paginationViewModel: PropTypes.shape({
        CurrentPageIndex: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        ResultsTotal: PropTypes.number,
        CurrentItemsOnPage: PropTypes.number
    }),
    onCurrentItemsPerPageChange: PropTypes.func,
    onCurrentPageIndexChange: PropTypes.func,
    onAttributeChange: PropTypes.func,
    onResultClick: PropTypes.func,
    showMoreFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleShowMoreFacet: PropTypes.func
};

export default ArticleSearchResults;
